import { ErrorHandler, Injectable } from "@angular/core";
import { MyMonitoringService } from "./logging.service";


@Injectable({providedIn: 'root'})
export class ErrorHandlerService extends ErrorHandler {

    constructor(private myMonitoringService: MyMonitoringService) {
        super();
    }

    override handleError(error: Error) {
        if (this.shouldIgnoreError(error)) {
            return;
        }

        this.myMonitoringService.logException(error); // Manually log exception
    }

    private shouldIgnoreError(error: Error): boolean {
        const message = error?.message;
        if (!message) {
            return false;
        }

        return MyMonitoringService.IgnoredErrorMessages.some((ignoredMessage) =>
            message.includes(ignoredMessage)
        );
    }
}
